import registryReducer from './registryReducer';

export default registryReducer;
